// src/App.js
import React, { useState, useEffect, Navigate } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import App from './App';
import App1 from './App1';
import App3 from './App3';
import BlankPage from './BlankPage';
import Login from './login';
import Signup from './signup';
import Navbar from './Navbar';
import Cookies from 'js-cookie';
import MapComponent from './MapComponent'
import Header from "./components/Header"
import Footerer from "./components/Footer"
import Footer from './components/Footer';
import ArcticMap from './example'
import { useLocation } from "react-router-dom";
import Section from "./components/Section";
import axios from 'axios';

function MainApp() {

  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [dynamicHeight, setDynamicHeight] = useState(0);

 function getQueryParameter(name) {
        const urlParams = new URLSearchParams(window.location.search);
        return urlParams.get(name);
    }

      
     

    
  useEffect(() => {
    const token = Cookies.get('token');
    if (token) {
      setIsAuthenticated(true);
    }

     

 // Function to adjust dynamic height based on window height
    const adjustHeight = () => {
      const baseHeight = 0; // Minimum height
      const windowHeight = window.innerHeight;
      const targetHeight = Math.max(baseHeight, 920 - windowHeight);
      
      setDynamicHeight(targetHeight);
    };

    // Initial check and add event listener for resize
    adjustHeight();
    window.addEventListener('resize', adjustHeight);

    // Cleanup event listener on unmount
    return () => window.removeEventListener('resize', adjustHeight);
      
  }, []);

  return (
  


     <Router basename='/map'>
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <Header />
        <main >
          <Routes>
            <Route path="/" element={<App />} />
            {/* Add other routes as needed */}
          </Routes>
        </main>
             <div style={{ height: `10px` }} />
        <Footer />
      </div>
    </Router>
  );
}

export default MainApp;
